import { UserContext } from "@src/context/UserContext";
import React, { useContext } from "react";
import { ActionCableConsumer } from "react-actioncable-provider";
import NotificationDropdown from "@components/Header/NotificationDropdown";
import { NotificationsDispatch } from "@src/context/NotificationsContext";

const NotificationWrapper: React.FC = React.memo(() => {
  const user = useContext(UserContext);
  const setNotifications = useContext(NotificationsDispatch);

  if (!user) return null;
  return (
    <ActionCableConsumer
      channel={{
        channel: "NotificationChannel",
        user: user.id,
      }}
      onReceived={(e) => {
        if (e.receiver === user.id) {
          setNotifications({ type: "addNotification", payload: e });
        }
      }}
    >
      <NotificationDropdown />
    </ActionCableConsumer>
  );
});

export default NotificationWrapper;
